import React from 'react'
import styles from "./DesignCard.module.css"

import initAOS from "../../utilities/AOS"
initAOS()

interface Props{
  img:any;
  header:string;
  text:string;
effect:string;
}
const DesignCard = (props:Props) => {
  return (

     
      <div data-aos={props.effect} className={`${styles.card} lg:m-0 m-auto text-white mb-[44px] flex rounded-[11.85px] w-[247px] h-[143px] md:w-[417px] md:mt-[0] mt-[4.344rem] md:h-[241px] `}>
      <div className='pl-[27px]  pb-[28px] pr-[21px] m-auto pt-[17px] pb-[35px]'>
      <img src={props.img} className="md:w-[64px] md:h-[64px] w-[37.91px] h-[37.91px]" alt="design img" />

      <header className='mt-[5.92px] md:text-[1.563rem] bold'>
        {props.header}
         </header>
      <p className='light mt-[1.69px] md:text-[0.875rem] text-[0.518rem]'>
        {props.text}
      </p>
      </div>
     
    </div>
  
      
 
  )
 
}

export default DesignCard
